document.addEventListener('DOMContentLoaded', () => {
  const copyBtns = document.querySelectorAll('.code-btn-row')
  copyBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      var code = btn.previousElementSibling.textContent
      const copied = btn.nextElementSibling
      navigator.clipboard.writeText(code)
      btn.classList.add('active')

      setTimeout(function () {
        btn.classList.remove('active')
      }, 3000)
    })
  })
})
